/**
 * Sticky primary ATC when below the fold (mobile).
 * Expects Liquid-rendered .product-buy-buttons--sticky-shell (no DOM moves).
 * Does not touch sticky-atc-bar.
 */
(() => {
  const MQ = '(max-width: 767px)';
  const STICKY_CLASS = 'is-below-fold-sticky';
  const ACTIVE_HTML_CLASS = 'primary-atc-below-fold-active';
  const PIN_EDGE_PX = 8;

  function init() {
    const productRoot = document.querySelector(
      '.product-page--root[data-mobile-meta-above-gallery="true"]'
    );
    if (!productRoot) return;

    const shell = productRoot.querySelector('.product-buy-buttons--sticky-shell');
    const button = shell?.querySelector('.product-buy-buttons--primary');
    const spacer = productRoot.querySelector('.product-buy-buttons--sticky-spacer');
    if (!shell || !button || !spacer) return;

    const media = window.matchMedia(MQ);
    let ticking = false;
    let pinned = false;

    const setSpacer = (height) => {
      spacer.style.height = height ? `${Math.round(height)}px` : '0px';
    };

    const pin = () => {
      if (pinned) return;
      setSpacer(button.offsetHeight);
      pinned = true;
      shell.classList.add(STICKY_CLASS);
      document.documentElement.classList.add(ACTIVE_HTML_CLASS);
      document.documentElement.style.setProperty(
        '--primary-atc-sticky-height',
        `${shell.offsetHeight}px`
      );
    };

    const release = () => {
      if (!pinned) return;
      pinned = false;
      shell.classList.remove(STICKY_CLASS);
      setSpacer(0);
      document.documentElement.classList.remove(ACTIVE_HTML_CLASS);
      document.documentElement.style.removeProperty('--primary-atc-sticky-height');
    };

    const sync = () => {
      ticking = false;
      if (!media.matches) {
        release();
        return;
      }

      const vh = window.innerHeight;
      if (pinned) {
        const padBottom = Number.parseFloat(getComputedStyle(shell).paddingBottom) || 0;
        const buttonHeight = spacer.offsetHeight || button.offsetHeight;
        const fixedButtonTop = vh - padBottom - buttonHeight;
        if (spacer.getBoundingClientRect().top <= fixedButtonTop) release();
      } else if (shell.getBoundingClientRect().top > vh + PIN_EDGE_PX) {
        pin();
      }
    };

    const onScrollOrResize = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(sync);
    };

    sync();
    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize, { passive: true });
    media.addEventListener('change', onScrollOrResize);

    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(() => {
        if (!pinned) return;
        setSpacer(button.offsetHeight);
        document.documentElement.style.setProperty(
          '--primary-atc-sticky-height',
          `${shell.offsetHeight}px`
        );
      }).observe(button);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
